<template>
  <!-- 底層-->
  <div class="isContactUs" v-if="isContactUs"></div>
  <div v-else class="contact-us-block" :class="{ isCyber: isCyber }">
    <div style="font-size: 32px; font-weight: 700; color: #ffffff">
      重視您的每一個需求
    </div>
    <div style="
        padding-top: 1rem;
        font-size: 20px;
        font-weight: 700;
        color: #ffffff;
      ">
      立即預約專人協助！
    </div>
    <div role="button" @click="goToByName('ContactUs')" class="contact-us-button" :class="{ isCyber: isCyber }"
      style="">
      <span>填寫表單</span>
    </div>
  </div>
  <div style="display: flex; flex-direction: column; align-items: center">
    <div class="footer-main">
      <div class="footer-group1">
        <div class="footer-logo">
          <StaticImage src="logo_hitrust.png" class="img-full" />
        </div>
        <div class="footer-divider"></div>
        <div class="footer-desc">
          網際威信集團旗下公司，守護數位商務安全，共創智能未來
        </div>

        <div class="footer-icon-group">
          <div role="button" style="width: 30px; height: 30px" data-toggle="tooltip" :title="phone">
            <StaticImage src="footer_phoen.png" class="img-full" />
          </div>
          <div role="button" style="width: 30px; height: 30px" @click="doMail">
            <StaticImage src="footer_mail.png" class="img-full" />
          </div>
          <div role="button" style="width: 30px; height: 30px" @click="doFB">
            <StaticImage src="footer_fb.png" class="img-full" />
          </div>
          <div role="button" style="width: 30px; height: 30px" @click="doYT">
            <StaticImage src="footer_yt.png" class="img-full" />
          </div>
          <div role="button" style="width: 30px; height: 30px" @click="doIG">
            <StaticImage src="footer_ig.png" class="img-full" />
          </div>
          <div role="button" style="width: 30px; height: 30px" @click="doLine">
            <StaticImage src="footer_line.png" class="img-full" />
          </div>
          <div role="button" style="width: 30px; height: 30px" @click="doLinkedIn">
            <StaticImage src="footer_linkedin.png" class="img-full" />
          </div>
        </div>
        <div class="footer-link">
          <div role="button" @click="goToByName('News')">最新消息</div>
        </div>
      </div>
      <div class="footer-group2">
        <div class="footer-group2-list">
          <div class="footer-item">
            <div class="footer-item-title">HiTRUSTpay</div>
            <div class="footer-item-link">
              <span role="button" @click="goToHiTRUSTpaySection('multi-payment')">
                多元支付服務
              </span>
            </div>
            <div class="footer-item-link">
              <span role="button" @click="goToHiTRUSTpaySection('hitrust-service')">
                商務加值服務
              </span>
            </div>
            <div class="footer-item-link">
              <span role="button" @click="goToByName('Shopify')"> Shopify 開店平台 </span>
            </div>
            <div class="footer-item-link">
              <span role="button" @click="goToByName('ThreeDS')"> 3DS 信用卡驗證服務 </span>
            </div>
          </div>
          <div class="footer-item">
            <div class="footer-item-title">智慧資安</div>
            <div class="footer-item-link">
              <span role="button" @click="goToByName('VeriId')"> AI 防詐 </span>
            </div>
            <div class="footer-item-link">
              <span role="button" @click="goToByName('VeriFido')"> 無密碼驗證 </span>
            </div>
            <div class="footer-item-link">
              <span role="button" @click="goToByName('SSL')"> 安全憑證 </span>
            </div>
            <div class="footer-item-link">
              <span role="button" @click="goToByName('Signing')"> 程式碼簽章 </span>
            </div>
          </div>
        </div>
        <div class="footer-group2-list">
          <div class="footer-item">
            <div class="footer-item-title">資源中心</div>
            <div class="footer-item-link">
              <span role="button" @click="goToByName('ApiDoc')"> 串接文件 </span>
            </div>
            <div class="footer-item-link">
              <span role="button" @click="goToByName('QA')"> 常見問題 </span>
            </div>
          </div>
          <div class="footer-item">
            <div class="footer-item-title">公司介紹</div>
            <div class="footer-item-link">
              <span role="button" @click="goToByName('AboutUs')"> 關於我們 </span>
            </div>
            <div class="footer-item-link">
              <span role="button" @click="goToByName('PrivacyPolicy')"> 隱私權政策 </span>
            </div>
            <div class="footer-item-link">
              <span role="button" @click="goToByName('Certificate')"> 專業認證&證書 </span>
            </div>
            <div class="footer-item-link">
              <span role="button" @click="goToByName('Award')"> 榮譽與獎項 </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Bottom copyright -->
    <div class="footer-bottom">
      <p>Copyright © {{ year }} HiTRUST All Rights Reserved.</p>
    </div>
  </div>
</template>

<script>
import { doFB, doYT, doIG, doLine, doLinkedIn } from "@/utils/ExternalUtil";

export default {
  data() {
    return {
      phone: "886 2 2658-9000",
      year: new Date().getFullYear()
    };
  },
  mounted() { },
  unmounted() { },
  watch: {},
  props: {},
  computed: {
    isCyber: function () {
      let meta = this.$route?.meta || {};
      return !!meta.isCyber;
    },
    isContactUs: function () {
      return this.$route?.name == "ContactUs";
    },
  },
  components: {},
  methods: {
    linkContactUs() {
      this.goTo({
        name: "ContactUs",
      });
    },
    doPhone() { },
    doMail() {
      const email = "sales@hitrust.com";
      const subject = encodeURIComponent("詢問 HiTRUSTpay 服務");

      // 組合 mailto 連結
      const mailtoLink = `mailto:${email}?subject=${subject}`;

      // 開啟預設信箱工具
      window.location.href = mailtoLink;
    },
    doFB() {
      doFB();
    },
    doYT() {
      doYT();
    },
    doIG() {
      doIG();
    },
    doLine() {
      doLine();
    },
    doLinkedIn() {
      doLinkedIn();
    },
    doNews() {
      router.push({ name: "News" });
    },
    goToByName(name) {
      this.goTo({
        name: name,
      });
    },
    goToHiTRUSTpaySection(id) {
      this.goTo({
        name: "HiTRUSTpay",
        params: { section: id },
      });
    },
    openUrl(url) {
      window.open(url, "_blank");
    },
  },
};
</script>
<style scoped>
/* 電腦版面 */
@media (min-width: 992px) {
  .footer-main {
    width: 100%;
    max-width: 1200px;
    padding: 2rem 1rem;
    box-sizing: border-box;
  }

  .footer-group1 {
    width: 520px;
    max-width: 40%;
  }

  .footer-logo {
    width: 310px;
    max-width: 100%;
    height: 80px;
  }

  .footer-desc {
    font-size: 16px;
  }

  .footer-link {
    font-weight: 500;
    font-size: 16px;
  }

  .footer-divider {
    margin: 20px 0;
  }

  .footer-bottom {
    text-align: right;
    border-top: 1px solid #1e1e1e;
    padding: 1rem;
    font-size: 16px;
    font-weight: 500;
    width: 100%;
    max-width: 1200px;
    box-sizing: border-box;
  }

  .footer-group2 {
    display: flex;
    gap: 3rem;
  }

  .footer-group2-list {
    display: flex;
    gap: 3rem;
  }

  .footer-item {
    width: max-content;
    white-space: normal;
  }

  .footer-item-title {
    font-size: 20px;
    font-weight: 700;
  }

  .footer-item-link {
    font-size: 16px;
    font-weight: 500;
  }
}

/** IPad */
@media (min-width: 768px) and (max-width: 991px) {
  .footer-main {
    flex-flow: column;
    border-bottom: 1px #1e1e1e;
    text-align: center;
  }

  .footer-group1 {
    padding: 2rem 0 1rem;
  }

  .footer-logo {
    width: 310px;
    height: 80px;
    margin: auto;
  }

  .footer-desc {
    font-size: 16px;
  }

  .footer-link {
    font-weight: 500;
    font-size: 16px;
    justify-content: center;
  }

  .footer-divider {
    margin: 20px auto;
  }

  .footer-icon-group {
    margin: auto;
  }

  .footer-bottom {
    text-align: right;
    border-top: 1px solid #1e1e1e;
    padding: 1rem;
    font-size: 16px;
    font-weight: 500;
  }

  .footer-group2 {
    padding: 1rem 0 3rem;
    display: flex;
    gap: 2rem;
    justify-content: center;
  }

  .footer-group2-list {
    display: flex;
    gap: 2rem;
  }

  .footer-item {
    width: max-content;
    white-space: normal;
  }

  .footer-item-title {
    font-size: 20px;
    font-weight: 700;
  }

  .footer-item-link {
    font-size: 16px;
    font-weight: 500;
  }
}

/* 手機版面 */
@media (max-width: 767px) {
  .footer-main {
    flex-flow: column;
    border-bottom: 1px #1e1e1e;
    text-align: center;
  }

  .footer-logo {
    width: 210px;
    height: 55px;
    margin: auto;
  }

  .footer-divider {
    margin: 20px auto;
  }

  .footer-desc {
    font-size: 13px;
  }

  .footer-link {
    font-weight: 500;
    font-size: 14px;
    justify-content: center;
  }

  .footer-icon-group {
    margin: auto;
  }

  .footer-bottom {
    text-align: center;
    border-top: 1px solid #1e1e1e;
    padding: 1rem;
    font-size: 12px;
    font-weight: 500;
    margin-top: 1rem;
  }

  .footer-group1 {
    padding: 2rem 0 1rem;
  }

  .footer-group2 {
    display: flex;
    flex-direction: column;
    width: 320px;
    max-width: 90vw;
    margin-left: auto;
    margin-right: auto;
  }

  .footer-group2-list {
    padding: 1rem 0;
    display: flex;
    justify-content: flex-start;
    width: 100%;
  }

  .footer-item:first-child {
    width: 175px;
    box-sizing: border-box;
  }

  .footer-item:last-child {
    width: 145px;
    box-sizing: border-box;
  }

  .footer-item-title {
    font-size: 16px;
    font-weight: 700;
    text-align: left;
  }

  .footer-item-link {
    font-size: 14px;
    font-weight: 500;
    text-align: left;
  }
}

.footer-item {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.contact-us-block {
  text-align: center;
  height: 350px;
  padding-top: 5rem;
  background: linear-gradient(90deg,
      var(--color-red) 0%,
      #cf4363 35%,
      #cf4363 65%,
      var(--color-red) 100%);
}

.contact-us-block.isCyber {
  background: linear-gradient(289.79deg,
      var(--cyber-color-start) var(--cyber-gradient-stop-1),
      var(--cyber-color-mid) var(--cyber-gradient-stop-2),
      var(--cyber-color-end) var(--cyber-gradient-stop-3));
}

.contact-us-button {
  width: 150px;
  height: 50px;
  background-color: #ffffff;
  border-radius: 60px;
  margin: 4rem auto;
  text-align: center;
  padding: 10px;
  font-size: 20px;
  font-weight: 500;
  color: #cf4363;
}

.contact-us-button.isCyber>span {
  display: inline-block;
  background: linear-gradient(289.79deg,
      var(--cyber-color-start) var(--cyber-gradient-stop-1),
      var(--cyber-color-mid) var(--cyber-gradient-stop-2),
      var(--cyber-color-end) var(--cyber-gradient-stop-3));
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}

.footer-main {
  display: flex;
  justify-content: center;
}

.footer-group:last-child {
  padding-top: 3rem;
}

.footer-group:last-child {
  padding-bottom: 3rem;
}

.footer-divider {
  width: 310px;
  height: 1px;
  background-color: #1e1e1e;
}

.footer-desc {
  font-weight: 500;
  padding: 1rem 0;
  max-width: 90%;
}

.vertical-divider {
  width: 1px;
  height: 20px;
  margin: 0 1rem;
  background: var(--color-red);
}

.footer-icon-group {
  width: 245px;
  display: flex;
  justify-content: space-between;
  padding: 1rem 0;
}

.footer-link {
  color: var(--color-red);
  display: flex;
  align-items: center;
}

.footer-bottom {
  width: 100%;
  max-width: 1200px;
  box-sizing: border-box;
}

.isContactUs {
  margin: auto;
  max-width: 80%;
  background: linear-gradient(90deg,
      #8c1c36 0%,
      #cf4363 35%,
      #cf4363 65%,
      #8c1c36 100%);
  height: 10px;
  border-radius: 10px;
}
</style>
